<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  mounted() {
    this.renderChart(
      {
        labels: [
          "Operator 1",
          "Operator 2",
          "Operator 3",
          "Operator 4",
          "Otomatik İşleme",
        ],
        datasets: [
          {
            label: "Sinyal İşleme Sayısı",
            backgroundColor: "#007bff",
            data: [382, 311, 448, 242, 498]
          },
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/General/Reports/components/Operators.vue